/* CDC · Message pour le vendeur (mission 2026-10-12-11, go de Julien du 12/10/2026).
 * Le message du panier (tiroir et page) n'était envoyé qu'avec le bouton « Valider la commande ». Un bouton de paiement express
 * (Shop Pay, PayPal…) part du panier sans envoyer ce formulaire : le message est donc enregistré dans le panier dès la saisie.
 * Écoute déléguée : le tiroir est redessiné après chaque ajout. Aucune donnée n'est envoyée ailleurs qu'au panier Shopify. */
(function () {
  'use strict';
  var SELECTOR = '.popup-cart textarea[name="note"], .cart textarea[name="note"]';
  var timer = null;
  var last = null;
  function save(value) {
    if (value === last) return;
    last = value;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    try {
      fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ note: value }) })
        .catch(function () { last = null; });
    } catch (error) { last = null; }
  }
  function field(event) { var target = event.target; return target && target.matches && target.matches(SELECTOR) ? target : null; }
  document.addEventListener('input', function (event) {
    var area = field(event); if (!area) return;
    window.clearTimeout(timer);
    timer = window.setTimeout(function () { save(area.value); }, 500);
  });
  document.addEventListener('change', function (event) {
    var area = field(event); if (!area) return;
    window.clearTimeout(timer); save(area.value);
  });
})();
